import { useContext, useState } from "react";
import ResponsiveTopBar from "../components/ResponsiveTopBar";
import ProfileComponent from "../components/ProfileComponent";
import MobileNavDrawer from "../components/MobileNavDrawer";
import { useParams } from "react-router-dom";
import { DeviceContext } from "../context/DeviceContext";

const ProfilePage = () => {
  const { username } = useParams();
  const { isMobile } = useContext(DeviceContext);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <ResponsiveTopBar isMobile={isMobile} onMobileMenuToggle={() => setMobileMenuOpen((prev) => !prev)} />
      <MobileNavDrawer open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
      <ProfileComponent username={username} />
    </>
  );
};

export default ProfilePage;
